import React from 'react';

const LoadingSpinner = () => {
  return (
    <div id='global-loader'>
      <div className='page-loader'></div>
    </div>
  );
};

export default LoadingSpinner;
